import { Controller, Payload } from "../../../controller";
import { ApplicationState } from "../../../store";
import { bindActionCreators, Dispatch } from "redux";

import { TabelaPrecoActions, TabelaPrecoConfig, TabelaPrecoState,initialValueTabelaPrecoState } from "./tabpreco.model"

export interface TabelaPrecoViewProps{
    tabelaPrecoState:TabelaPrecoState
    tabelaPrecoActions:TabelaPrecoActions
}


class TabelaPrecoController extends Controller<TabelaPrecoConfig, TabelaPrecoState, TabelaPrecoActions> {
    constructor() {
        super(initialValueTabelaPrecoState.row.type, initialValueTabelaPrecoState);

        this.actionsType = {
            ...this.actionsType,
            //inserir aqui os novos actionsTypes
        };

        this.reducer.actions = {
            ...this.reducer.actions,
            //inserir aqui os novos actions
        }

        this.actionEffects = [
            ...this.actionEffects,
            //inserir aqui os novos Effects
        ]
    }

    private* novoActionEffects(actions:Payload){

    }
}

export const tabelaPrecoController = new TabelaPrecoController()

export const mapStateToTabelaPrecoProps = (state: ApplicationState) => ({
    tabelaPrecoState: state.tabelaPrecoState,
})

export const mapDispatchToTabelaPrecoProps = (dispatch: Dispatch) => ({
    tabelaPrecoActions: bindActionCreators({...tabelaPrecoController.reducer.actions}, dispatch),
})